module.exports = __webpack_public_path__ + "static/media/icon-home.9a6eee77.svg";